export default ['mrburns.local', 'mrburns.staging.bas.app', 'mrburns.bas.app'];
